import script from "./PosList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PosList.vue?vue&type=script&lang=ts&setup=true"

import "./PosList.vue?vue&type=style&index=0&id=04d36f74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d36f74"]])

export default __exports__